module.exports = __webpack_public_path__ + "img/积分商城-灰.3ff8d74a.png";